import axios from '../assets/js/http'
import qs from 'qs'
// 登录
export const login = params => {
  return axios.post(`/gov-api/passPort/login`, qs.stringify(params)).then(res => res.data)
}
// 公司案例
export const companyCase = params => {
  return axios.get(`/gov-api/companycase/getPageList`, { params: params })
}
export const getCompanyCaseById = params => {
  return axios.get(`/gov-api/companycase/getCompanyCaseById`, { params: params, headers: {'Token': sessionStorage.getItem('token')} })
}
export const addCompanyCase = params => {
  return axios({
    method: 'post',
    url: '/gov-api/companycase/addCompanyCase',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateCompanyCase = params => {
  return axios({
    method: 'post',
    url: '/gov-api/companycase/updateCompanyCase',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
// 企业资讯
export const companyNews = params => {
  return axios.get(`/gov-api/companynews/getPageList`, { params: params })
}
export const getCompanyNewsById = params => {
  return axios.get(`/gov-api/companynews/getCompanyNewsById`, { params: params, headers: {'Token': sessionStorage.getItem('token')} })
}
export const addCompanyNews = params => {
  return axios({
    method: 'post',
    url: '/gov-api/companynews/addCompanyNews',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateCompanyNews = params => {
  return axios({
    method: 'post',
    url: '/gov-api/companynews/updateCompanyNews',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
// 客户服务
export const customerService = params => {
  return axios.get(`/gov-api/customerservice/getPageList`, { params: params })
}
export const customerServiceDetail = params => {
  return axios.get(`/gov-api/customerservice/getCustomerServiceById`, { params: params })
}
export const addCustomerService = params => {
  return axios({
    method: 'post',
    url: '/gov-api/customerservice/addCustomerService',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateCustomerService = params => {
  return axios({
    method: 'post',
    url: '/gov-api/customerservice/updateCustomerService',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
// 顾问招募
// 预约报名
export const getPageList = params => {
  return axios.get(`/gov-api/consultantjoin/getPageList`, { params: params })
}
export const addConsultantJoin = params => {
  return axios.post(`/gov-api/consultantjoin/addConsultantJoin`, qs.stringify(params)).then(res => res.data)
}
// 顾问招募 --> 图片上传

// 往期回顾
export const revieWtrain = params => {
  return axios.get(`/gov-api/reviewtrain/getPageList`, { params: params })
}
export const addReviewTrain = params => {
  return axios({
    method: 'post',
    url: '/gov-api/reviewtrain/addReviewTrain',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateReviewTrain = params => {
  return axios({
    method: 'post',
    url: '/gov-api/reviewtrain/updateReviewTrain',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
// 加入我们
export const joingetPageList = params => {
  return axios.get(`/gov-api/joinus/getPageList`, { params: params })
}
export const addJoinUs = params => {
  return axios({
    method: 'post',
    url: '/gov-api/joinus/addJoinUs',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateJoinUs = params => {
  return axios({
    method: 'post',
    url: '/gov-api/joinus/updateJoinUs',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
// 顾问体验
export const consulexGetPageList = params => {
  return axios.get(`/gov-api/consultantexperience/getPageList`, { params: params })
}
export const addConsultant = params => {
  return axios.post(`/gov-api/consultantexperience/addConsultantExperience`, qs.stringify(params)).then(res => res.data)
}
// 活动印花
export const activityGetPageList = params => {
  return axios.get(`/gov-api/activityimgs/getPageList`, { params: params })
}
export const getActivityImgsById = params => {
  return axios.get(`/gov-api/activityimgs/getActivityImgsById`, { params: params, headers: {'Token': sessionStorage.getItem('token')} })
}
export const addActivityImgs = params => {
  return axios({
    method: 'post',
    url: '/gov-api/activityimgs/addActivityImgs',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}
export const updateActivityImgs = params => {
  return axios({
    method: 'post',
    url: '/gov-api/activityimgs/updateActivityImgs',
    data: qs.stringify(params),
    headers: {
      'Token': sessionStorage.getItem('token')
    }
  }).then(res => res.data)
}


export const getCompanyProductById =params=>{
  return axios.get(`/gov-api/companyproduct/getCompanyProductById`, { params: params, headers: {'Token': sessionStorage.getItem('token')} })
}
export const getProductList =params=>{
  return axios.get(`gov-api/companyproduct/getProductList`, { params: params})
}
export const getProductTypeList =params=>{
  return axios.get(`gov-api/companyproduct/getProductTypeList`, { params: params})
}



// WEBPACK FOOTER //
// ./src/api/api.js